import { render } from "./Odd.vue?vue&type=template&id=5e4b46ca"
import script from "./Odd.vue?vue&type=script&lang=js"
export * from "./Odd.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__